import { GET_FACILIDADES } from './mutation-types'

export default {
  [GET_FACILIDADES]: (state, facilidades) => {
    state.facilidades = facilidades
  },
}
